<template>
  <v-bottom-sheet
    inset
    max-width="600px"
    scrollable
    v-model="editStore.editSubtitles"
  >
    <SubtitlesEditCard />
  </v-bottom-sheet>
</template>

<script>
import { useEditStore } from "@/stores/edit";
import SubtitlesEditCard from "@/components/edit/SubtitlesEditCard.vue";

export default {
  name: "ShortDetailBottomSheet",
  components: {
    SubtitlesEditCard,
  },
  setup() {
    const editStore = useEditStore();
    return { editStore };
  },
};
</script>

<style scoped>
:deep(.v-bottom-sheet),
:deep(.v-bottom-sheet .v-card) {
  border-radius: 16px 16px 0 0;
}
</style>